export let emptyFolderText = "cP3upc";
export default {emptyFolderText};